import { createContext } from 'react'

import { initialUserState } from 'state/user/utils'

const UserContext = createContext(initialUserState)

export default UserContext
